import { render } from "./PartnersByEntityChart.vue?vue&type=template&id=86f1dc22&scoped=true"
import script from "./PartnersByEntityChart.vue?vue&type=script&lang=js"
export * from "./PartnersByEntityChart.vue?vue&type=script&lang=js"

import "./PartnersByEntityChart.vue?vue&type=style&index=0&id=86f1dc22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-86f1dc22"

export default script